import React from 'react'
import { Info } from 'lucide-react';
import Seo from './Seo';

const ContactUs = () => {
    return (
        <div className="page pt-32">
            <Seo
                title="Contact Us | CompressImages.org"
                description="Have questions or feedback? Get in touch with the CompressImages.org team via email."
                path="/contact"
            />

            <div className="contact-wrap">
                <div className="section-hd">
                    <h1>Contact us</h1>
                    <p>Questions, bug reports, or feedback. We read everything.</p>
                </div>

                <div className="privacy-card" style={{ maxWidth: '100%' }}>
                    <div className="privacy-icon"><Info /></div>
                    <div>
                        <div className="privacy-title">Before writing in</div>
                        <div className="privacy-text">
                            If you have a technical question about formats, file sizes, or privacy, check the tool FAQ first.
                        </div>
                    </div>
                </div>

                <p style={{ color: 'var(--text-body)', lineHeight: 1.7 }}>
                    Email us at{' '}
                    <a href="mailto:contact@compressimages.org" style={{ color: 'var(--cyan-dim)', textDecoration: 'underline', textUnderlineOffset: 2 }}>
                        contact@compressimages.org
                    </a>
                    . We usually respond within 24-48 hours.
                </p>
            </div>
        </div>
    )
}

export default ContactUs
